/**
 * safePath — base64url encode/decode for URL path parameters that may contain
 * characters disallowed (or stripped) by reverse proxies, notably `/`.
 *
 * Use cases (TLC ERP):
 *   - contract_no / annex_no có format `PL01/S-02445` (chứa `/`)
 *   - encodeURIComponent → `%2F` không an toàn vì một số proxy (nginx, CDN) reject
 *     hoặc decode trước khi reach backend → URL pattern không match route.
 *
 * Pattern:
 *   FE: `url: \`/.../\${safePathEncode(annexNo)}/print/vn\``
 *   BE: `annex_no = safe_path_decode(annex_no_raw)`
 *
 * RFC 4648 base64url alphabet: A–Z a–z 0–9 - _   (không có /, +, =)
 */

/** Encode arbitrary UTF-8 string to base64url (no padding). */
export function safePathEncode(value: string): string {
  // Step 1: UTF-8 encode (btoa only handles Latin-1 → escape/unescape bridge)
  const utf8 = unescape(encodeURIComponent(value))
  // Step 2: base64 then convert to URL-safe
  return btoa(utf8)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

/** Decode base64url back to UTF-8. */
export function safePathDecode(value: string): string {
  // Restore standard base64 alphabet + padding
  let std = value.replace(/-/g, '+').replace(/_/g, '/')
  const pad = std.length % 4
  if (pad === 2) std += '=='
  else if (pad === 3) std += '='
  else if (pad === 1) throw new Error('Invalid base64url length')
  const utf8 = atob(std)
  return decodeURIComponent(escape(utf8))
}
